import PropTypes from 'prop-types'
import { memo } from 'react'
import { useIntl } from 'react-intl'
import { ROLES } from '../../../../../containers/TeamsManagement/constants'
import { badgeColorOptions } from '../../../../stories/atoms/badges/constants'
import ListItemComponent from '../../../../stories/molecules/list-items'
import { iconSizeOptions } from '../../../../stories/atoms/icons/icons-sizes'
import StatusIndicationComponent from '../../../../stories/atoms/status-indication'
import { statusIndicationMemberVariantOptions } from '../../../../stories/atoms/status-indication/constants'

const handleRoleColor = (role) => {
  switch (role) {
    case ROLES.POWERUSER:
      return badgeColorOptions.VIOLET
    case ROLES.ASSISTANT:
      return badgeColorOptions.BLUE
    case ROLES.EXTERNALVISITOR:
      return badgeColorOptions.TURQUOISE
    case ROLES.SUBCONTRACTOR:
      return badgeColorOptions.OCHRE
    case ROLES.VIEWER:
      return badgeColorOptions.GREEN
    default:
      return badgeColorOptions.OCHRE
  }
}

const TeamItem = ({ item }) => {
  const { formatMessage } = useIntl()

  return (
    <ListItemComponent.Item
      itemKey={item.id}
      leadingIcon={
        <StatusIndicationComponent
          size={iconSizeOptions['ICON-L']}
          variant={statusIndicationMemberVariantOptions.TEAM}
          iconNotEnclosed
        />
      }
      title={`${item.name}`}
      secondaryText={formatMessage(
        { id: 'member' },
        { count: item.members.length }
      )}
      badge={{
        label:
          formatMessage({ id: `personas_roleLabel${item.role}` }) || item.role,
        color: handleRoleColor(item.role)
      }}
      style={{ borderRadius: 0, border: 0 }}
      noPadding
    />
  )
}

TeamItem.propTypes = {
  item: PropTypes.object
}

const MemoizedTeamItem = memo(TeamItem)
MemoizedTeamItem.displayName = 'TeamItem'

export default MemoizedTeamItem
